// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","CategoriesList":"bj_a bhl_ea bhl_ke bhl_ju bhl_wl"};